<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">工厂制造行业解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        随着工业
                        4.0的深入推进和智能制造的快速发展，工厂制造行业正朝着数字化、智能化方向加速转型。在这一过程中，信息的精准传递和高效管理成为提升生产效率、保障产品质量的关键。热敏打印机作为工厂信息可视化的重要设备，广泛应用于生产工单打印、物料标签标识、产品追溯标签制作等环节。其打印速度、稳定性、耐用性以及与
                        MES（制造执行系统）等管理系统的兼容性，直接关系到生产流程的顺畅性、物料管理的准确性和产品追溯的可靠性，是支撑工厂制造数字化转型的重要基础设施。

                        从生产计划下达、物料领用，到生产过程跟踪、成品入库，热敏打印的各类标签和工单贯穿于制造全流程，为生产各环节提供清晰的信息指引，助力工厂实现精细化管理。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="tabList[activeTabIndex].beds.length === 4">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">{{ bed.text }}</div>
                            <img v-if="index === 0" class="business-block-item-img" src="../images/icon4.png"
                                 alt="img"/>
                            <img v-else-if="index === 1" class="business-block-item-img" src="../images/icon5.png"
                                 alt="img"/>
                            <img v-else-if="index === 2" class="business-block-item-img" src="../images/icon6.png"
                                 alt="img"/>
                            <img v-else-if="index === 3" class="business-block-item-img" src="../images/icon7.png"
                                 alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else>
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-text">{{ bed.text }}</div>
                        <img v-if="index===0" class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        <img v-else-if="index===1" class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        <img v-else-if="index===2" class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <template v-if="activeTabIndex ===0">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/118D.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-118</span> 系列热敏标签打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                具备防油污、防尘、抗振动设计
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：100-200mm/s<br/>
                                分辨率：203-300dpi<br/>
                                支持纸张宽度：58-108mm<br/>
                                接口：usb、WiFi<br/>
                                日均打印量：2000-3000单<br/>
                                适用场景：汽车零部件、电子装配、机械制造等生产线场景。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                番茄打印管家支持从MES系统打通自动抓取生产工单数据，按生产线、工序自动分配打印任务；提供工单模板自定义功能，可灵活添加工艺图纸缩略图、操作指引等内容；实时反馈工单打印状态，确保生产数据闭环管理。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="../KDWL/images/gj-bg.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/118D.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-118E</span> 系列热敏标签打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                支持多规格标签打印，打印清晰耐用
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：150mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：20-110mm<br/>
                                接口：usb、WiFi<br/>
                                日均打印量：1000-5000单<br/>
                                适用场景：工厂原材料仓库、零部件库、成品库等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家和快麦云API
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                配合快麦云接口支持从 WMS
                                系统同步物料基础数据和库存信息，一键生成物料标签和库位标签；提供标签批量打印功能，支持按入库单、出库单自动批量生成标签；支持标签打印记录查询，便于追溯标签更换历史。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/bg.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/KM-360C.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-360C</span> 在线式热敏标识打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                可集成到生产线自动化设备中实现自动打印贴标
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：80mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：40-80mm<br/>
                                接口：usb、蓝牙<br/>
                                日均打印量：500-1500单<br/>
                                适用场景：食品加工、医疗器械、电子产品等需要严格质量追溯的行业
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                番茄打印管家和快麦云API
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持根据产品型号自定义追溯标签模板，包含各类追溯要素；与质量检测系统对接，自动获取质检数据并打印到标签上；支持通过二维码关联生产过程数据，扫码即可查询产品全流程追溯信息。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/bg.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        汽车零部件工厂在生产线部署快麦 KM-118G 打印机和番茄打印管家后，工单打印响应时间从原来的 5 分钟缩短至
                        10 秒，生产线因工单问题导致的停机时间减少了 90%，设备故障率降低了 70%，生产计划达成率提升了 15%。
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        电子制造工厂引入快麦 KM-118ME 标签打印机和番茄打印管家仓储模块后，物料标签错误率降低了
                        95%，仓库盘点时间缩短了 60%，因物料错发导致的生产延误减少了 80%，库存周转率提升了 25%，显著降低了仓储管理成本。
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        医疗器械工厂采用快麦 KM-360P在线式打印机和番茄打印管家质量追溯模块后，产品追溯标签准确率达到
                        100%，质量问题追溯时间从原来的 2 天缩短至 2 小时，因标签问题导致的召回风险降低了
                        90%，顺利通过了行业质量体系认证，客户对产品质量的信任度显著提升。
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "GYZZ",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '生产线工单与工序标识',
                    title: '生产线工单与工序标识',
                    subtitle: '工厂生产线是产品制造的核心区域，每条生产线日均需处理数十至上百批次的生产任务。需要根据生产计划实时打印包含产品型号、生产数量、工序要求、工艺参数、截止时间等信息的生产工单，以及各工序的标识标签，指导工人按规范操作，确保生产有序进行。',
                    solution: '部署工业级耐环境热敏打印机和番茄打印管家生产管理模块，构建生产线智能工单打印系统。',
                    beds: [
                        {
                            title: '工单打印滞后影响生产',
                            text: '传统打印机响应速度慢，在生产计划调整或紧急插单时，工单打印不及时，导致生产线停工等待，影响生产效率。'
                        },
                        {
                            title: '车间环境设备易损坏',
                            text: '生产线环境复杂，存在粉尘、油污、振动等情况，传统打印机防护性能不足，易出现故障，增加维修成本和停机时间。'
                        },
                        {
                            title: '工单与系统数据不同步',
                            text: '人工打印工单易出现漏打、错打现象，且工单信息与 MES 系统数据不同步，导致生产进度跟踪困难，无法准确掌握实时生产状态。'
                        },
                    ],
                    goods: [
                        {
                            title: '高速响应保障生产节奏',
                            text: '工业级热敏打印机打印速度可达 200mm/s 以上，能快速响应生产计划变化，实时打印工单，避免生产线因等待工单而停机，保障生产连续性。'
                        },
                        {
                            title: '坚固耐用适应车间环境',
                            text: '打印机采用全金属外壳和密封设计，具备 IP54 级防尘防水性能，能抵御车间粉尘、油污和轻微振动，降低设备故障率，减少维修成本。'
                        },
                        {
                            title: '数据联动实现精准管理',
                            text: '与 MES 系统深度对接，自动接收生产计划数据并生成工单，实现工单打印与系统数据实时同步，避免人工操作错误，便于生产进度实时跟踪和管理。'
                        },
                    ]
                },
                {
                    tabName: '工厂仓储与物料管理',
                    title: '工厂仓储与物料管理',
                    subtitle: '工厂仓库负责原材料、零部件和成品的存储与管理，日均需处理大量的物料入库、出库、盘点和调拨业务。需要打印包含物料编码、名称、规格、批次、数量、库位等信息的物料标签，确保物料收发准确，库存状态清晰。',
                    solution: '部署热敏标签打印机 和番茄打印管家，构建工厂物料智能标签管理系统。',
                    beds: [
                        {
                            title: '物料标签易磨损难识别',
                            text: '传统纸质标签在仓储环境中易因摩擦、潮湿而磨损，导致物料信息模糊不清，增加物料查找和盘点难度，易出现错发、漏发问题。'
                        },
                        {
                            title: '标签信息录入效率低',
                            text: '物料标签信息多依赖人工手动录入和打印，不仅耗时费力，还容易出现编码错误、规格不符等问题，影响物料管理准确性。'
                        },
                        {
                            title: '库位标签更新不及时',
                            text: '当物料库位调整时，传统标签更换流程繁琐，更新不及时，导致系统库位信息与实际不符，增加仓储管理成本。'
                        },
                    ],
                    goods: [
                        {
                            title: '耐用标签保障信息持久',
                            text: '采用工业级热敏标签纸，具备防水、防油、耐摩擦、抗撕裂特性，确保物料标签在仓储全生命周期内清晰可辨，减少标签更换频率。'
                        },
                        {
                            title: '数据对接减少人工错误',
                            text: '与 WMS（仓储管理系统）无缝对接，自动获取物料信息生成标签，无需人工录入，确保标签信息与系统数据一致，降低错误率。'
                        },
                        {
                            title: '快速更新提升库位准确率',
                            text: '支持库位标签快速打印和更换，当物料库位调整时，可实时生成新标签，确保系统库位信息与实际位置同步，提升仓储管理效率。'
                        },
                    ]
                },
                {
                    tabName: '产品质量追溯与标识',
                    title: '产品质量追溯与标识',
                    subtitle: '在工厂制造过程中，产品质量追溯至关重要，需要对产品从原材料投入到成品出厂的全流程进行信息记录。需在产品或包装上打印包含生产日期、批次号、序列号、质检信息、追溯二维码等内容的标识标签，以便在出现质量问题时快速追溯根源。',
                    solution: '部署便携热敏标签打印机和番茄打印管家，构建产品全生命周期追溯标识系统。',
                    beds: [
                        {
                            title: '追溯标签信息不全或模糊',
                            text: '传统打印方式输出的追溯标签信息不完整，或因打印质量差导致信息模糊，无法实现有效追溯，增加质量问题处理难度。'
                        },
                        {
                            title: '标签与产品关联不准确',
                            text: '人工粘贴标签易出现标签与产品错配情况，导致追溯信息失真，无法准确关联产品生产过程数据。'
                        },
                        {
                            title: '多品种标签切换繁琐',
                            text: '工厂生产产品品种多、规格杂，不同产品追溯标签格式不同，传统打印机切换标签格式操作复杂，易出现设置错误。'
                        },
                    ],
                    goods: [
                        {
                            title: '高清完整记录追溯信息',
                            text: '打印机具备高分辨率打印能力，确保追溯标签上的文字、二维码等信息清晰完整，可准确识别，为质量追溯提供可靠依据。'
                        },
                        {
                            title: '自动关联确保信息准确',
                            text: '与质量追溯系统和生产设备联动，在产品生产过程中自动打印并粘贴标签（或通过自动化设备实现），确保标签与产品唯一对应，避免人工错贴。'
                        },
                        {
                            title: '灵活切换适应多品种生产',
                            text: '支持标签模板快速切换和自定义，可根据不同产品型号一键调用对应的标签格式，减少格式切换时间和错误率，适应多品种柔性生产需求。'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
